import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, Star, MessageSquare, AlertTriangle, CheckCircle, X } from 'lucide-react';
const CUSTOMER_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Database',
  path: 'database'
}, {
  label: 'Segments',
  path: 'segments'
}, {
  label: 'Reviews',
  path: 'reviews'
}, {
  label: 'Insights',
  path: 'insights'
}];
const REVIEWS = [{
  id: 1,
  rating: 10,
  text: 'Najbolji burgeri u gradu!',
  platform: 'Wolt',
  location: 'Vračar',
  time: '2 hours ago',
  author: 'Marko P. (VIP)',
  status: 'Responded'
}, {
  id: 2,
  rating: 9,
  text: 'Odlične palačinke, extra nutela 👌',
  platform: 'Google',
  location: 'NBG',
  time: '4 hours ago',
  author: 'Jelena K.',
  status: 'Needs Response'
}, {
  id: 3,
  rating: 10,
  text: 'Great smash burgers, fast delivery',
  platform: 'TripAdvisor',
  location: 'Vračar',
  time: 'Yesterday',
  author: 'John D.',
  status: 'Responded'
}, {
  id: 4,
  rating: 8,
  text: 'Burger odličan, pomfrit mogao biti topliji',
  platform: 'Wolt',
  location: 'Zemun',
  time: 'Yesterday',
  author: 'Stefan S.',
  status: 'Needs Response'
}];
const NEEDS_ATTENTION = [{
  id: 5,
  rating: 5,
  text: 'Pogrešna narudžbina, dobio sam tuđe.',
  platform: 'Wolt',
  location: 'Banovo Brdo',
  time: '3 hours ago',
  details: 'Order #4521 · Customer: New'
}, {
  id: 6,
  rating: 6,
  text: 'Hrana stigla hladna, čekao sam 45 minuta',
  platform: 'Wolt',
  location: 'Banovo Brdo',
  time: '5 hours ago',
  details: 'Order #4498 · Customer: Returning'
}];
export function Reviews() {
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState<any>(null);
  const handleRespond = (review: any) => {
    setSelectedReview(review);
    setShowResponseModal(true);
  };
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1037">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1038">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1039">Reviews</h1>
        <div className="flex flex-wrap gap-3 items-center" data-id="element-1040">
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1041">
            All Locations <ChevronDown size={14} data-id="element-1042" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1043">
            All Platforms <ChevronDown size={14} data-id="element-1044" />
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1045">
            Status <ChevronDown size={14} data-id="element-1046" />
          </button>
          <div className="relative" data-id="element-1047">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-1048" />
            <input type="text" placeholder="Search reviews..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-48" data-id="element-1049" />
          </div>
        </div>
      </div>

      <TabNavigation tabs={CUSTOMER_TABS} basePath="/customers" data-id="element-1050" />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1051">
        <Card className="p-4" data-id="element-1052">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-1053">
            <MessageSquare size={16} data-id="element-1054" /> Total Reviews
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-1055">1,247</div>
        </Card>
        <Card className="p-4" data-id="element-1056">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-1057">
            <Star size={16} data-id="element-1058" /> Avg Rating
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-1059">9.1 / 10</div>
        </Card>
        <Card className="p-4" data-id="element-1060">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-1061">
            <CheckCircle size={16} data-id="element-1062" /> Response Rate
          </div>
          <div className="text-2xl font-bold mb-1" data-id="element-1063">78%</div>
        </Card>
        <Card className="p-4" data-id="element-1064">
          <div className="flex items-center gap-2 text-sm text-text-secondary mb-1" data-id="element-1065">
            <AlertTriangle size={16} data-id="element-1066" /> Negative (&lt;7)
          </div>
          <div className="text-2xl font-bold mb-1 text-accent-error" data-id="element-1067">
            42 (3.4%)
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1068">
        {/* Rating Distribution */}
        <Card className="p-6" data-id="element-1069">
          <h3 className="font-bold mb-4" data-id="element-1070">Rating Distribution</h3>
          <div className="space-y-3" data-id="element-1071">
            {[{
            label: '⭐ 10',
            pct: 52,
            color: 'bg-accent-success'
          }, {
            label: '⭐ 9',
            pct: 28,
            color: 'bg-accent-success/70'
          }, {
            label: '⭐ 8',
            pct: 12,
            color: 'bg-yellow-500'
          }, {
            label: '⭐ 7',
            pct: 5,
            color: 'bg-orange-500'
          }, {
            label: '⭐ 1-6',
            pct: 3,
            color: 'bg-accent-error'
          }].map((item, i) => <div key={i} className="flex items-center gap-3 text-sm" data-id="element-1072">
                <span className="w-12 font-medium" data-id="element-1073">{item.label}</span>
                <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-1074">
                  <div className={`h-full ${item.color}`} style={{
                width: `${item.pct}%`
              }} data-id="element-1075"></div>
                </div>
                <span className="w-8 text-right text-text-secondary" data-id="element-1076">
                  {item.pct}%
                </span>
              </div>)}
          </div>
        </Card>

        {/* By Location */}
        <Card className="p-6" data-id="element-1077">
          <h3 className="font-bold mb-4" data-id="element-1078">By Location</h3>
          <div className="space-y-3" data-id="element-1079">
            {[{
            name: 'Vračar',
            rating: 9.3,
            width: 93
          }, {
            name: 'NBG Milutina',
            rating: 9.2,
            width: 92
          }, {
            name: 'Banovo Brdo',
            rating: 8.8,
            width: 88,
            warning: true
          }].map((loc, i) => <div key={i} data-id="element-1080">
                <div className="flex justify-between text-sm mb-1" data-id="element-1081">
                  <span className="font-medium" data-id="element-1082">{loc.name}</span>
                  <div className="flex items-center gap-2" data-id="element-1083">
                    <span className="font-bold" data-id="element-1084">{loc.rating} ⭐</span>
                    {loc.warning && <AlertTriangle size={12} className="text-accent-warning" data-id="element-1085" />}
                  </div>
                </div>
                <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-1086">
                  <div className={`h-full ${loc.warning ? 'bg-accent-warning' : 'bg-accent-primary'}`} style={{
                width: `${loc.width}%`
              }} data-id="element-1087"></div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* By Platform */}
        <Card className="p-6" data-id="element-1088">
          <h3 className="font-bold mb-4" data-id="element-1089">By Platform</h3>
          <div className="space-y-3" data-id="element-1090">
            {[{
            name: 'Wolt',
            rating: 9.2,
            count: 892,
            color: 'text-blue-400'
          }, {
            name: 'Google',
            rating: 8.9,
            count: 234,
            color: 'text-red-400'
          }, {
            name: 'TripAdvisor',
            rating: 9.0,
            count: 89,
            color: 'text-green-400'
          }, {
            name: 'Collina.rs',
            rating: 9.4,
            count: 32,
            color: 'text-accent-primary'
          }].map((platform, i) => <div key={i} className="flex justify-between items-center p-2 bg-white/5 rounded" data-id="element-1091">
                <span className={`font-bold ${platform.color}`} data-id="element-1092">
                  {platform.name}
                </span>
                <div className="text-right" data-id="element-1093">
                  <div className="font-bold text-sm" data-id="element-1094">{platform.rating} ⭐</div>
                  <div className="text-xs text-text-secondary" data-id="element-1095">
                    {platform.count} reviews
                  </div>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* Needs Attention */}
      <h3 className="font-bold text-accent-error flex items-center gap-2 uppercase tracking-wider text-sm mt-4" data-id="element-1096">
        <AlertTriangle size={18} data-id="element-1097" /> Needs Attention
      </h3>
      <div className="space-y-3" data-id="element-1098">
        {NEEDS_ATTENTION.map(review => <Card key={review.id} className="p-4 border border-accent-error/20 bg-accent-error/5" data-id="element-1099">
            <div className="flex flex-col md:flex-row justify-between gap-4" data-id="element-1100">
              <div data-id="element-1101">
                <div className="flex items-center gap-2 mb-2" data-id="element-1102">
                  <span className="font-bold text-accent-error flex items-center gap-1" data-id="element-1103">
                    <Star size={14} fill="currentColor" data-id="element-1104" /> {review.rating}
                  </span>
                  <span className="text-text-secondary text-sm" data-id="element-1105">
                    {review.platform} · {review.location} · {review.time}
                  </span>
                </div>
                <p className="font-medium mb-2" data-id="element-1106">"{review.text}"</p>
                <div className="text-xs text-text-secondary" data-id="element-1107">
                  {review.details}
                </div>
              </div>
              <div className="flex gap-2 self-start" data-id="element-1108">
                <Button size="sm" variant="secondary" data-id="element-1109">
                  View Order
                </Button>
                <Button size="sm" onClick={() => handleRespond(review)} data-id="element-1110">
                  Mark Responded
                </Button>
              </div>
            </div>
          </Card>)}
      </div>

      {/* All Reviews List */}
      <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm mt-4" data-id="element-1111">
        All Reviews
      </h3>
      <div className="space-y-3" data-id="element-1112">
        {REVIEWS.map(review => <Card key={review.id} className="p-4" data-id="element-1113">
            <div className="flex flex-col md:flex-row justify-between gap-4" data-id="element-1114">
              <div data-id="element-1115">
                <div className="flex items-center gap-2 mb-2" data-id="element-1116">
                  <span className={`font-bold flex items-center gap-1 ${review.rating >= 9 ? 'text-accent-success' : 'text-yellow-500'}`} data-id="element-1117">
                    <Star size={14} fill="currentColor" data-id="element-1118" /> {review.rating}
                  </span>
                  <span className="text-text-secondary text-sm" data-id="element-1119">
                    {review.platform} · {review.location} · {review.time}
                  </span>
                </div>
                <p className="font-medium mb-2" data-id="element-1120">"{review.text}"</p>
                <div className="text-xs text-text-secondary" data-id="element-1121">
                  {review.author}
                </div>
              </div>
              <div className="self-start" data-id="element-1122">
                {review.status === 'Responded' ? <div className="flex items-center gap-1 text-xs font-bold text-accent-success bg-accent-success/10 px-2 py-1 rounded" data-id="element-1123">
                    <CheckCircle size={12} data-id="element-1124" /> Responded
                  </div> : <Button size="sm" variant="secondary" onClick={() => handleRespond(review)} data-id="element-1125">
                    Reply
                  </Button>}
              </div>
            </div>
          </Card>)}
      </div>

      {/* Response Modal */}
      {showResponseModal && selectedReview && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-1126">
          <Card className="w-full max-w-lg" data-id="element-1127">
            <div className="flex justify-between items-center mb-6" data-id="element-1128">
              <h3 className="text-xl font-bold" data-id="element-1129">Mark as Responded</h3>
              <button onClick={() => setShowResponseModal(false)} className="text-text-secondary hover:text-white" data-id="element-1130">
                <X size={20} data-id="element-1131" />
              </button>
            </div>

            <div className="bg-white/5 p-4 rounded-lg mb-6" data-id="element-1132">
              <div className="flex items-center gap-2 mb-2" data-id="element-1133">
                <span className="font-bold text-accent-error flex items-center gap-1" data-id="element-1134">
                  <Star size={14} fill="currentColor" data-id="element-1135" /> {selectedReview.rating}
                </span>
                <span className="text-text-secondary text-sm" data-id="element-1136">
                  {selectedReview.platform} · {selectedReview.location} ·{' '}
                  {selectedReview.time}
                </span>
              </div>
              <p className="font-medium" data-id="element-1137">"{selectedReview.text}"</p>
            </div>

            <div className="space-y-4 mb-6" data-id="element-1138">
              <div data-id="element-1139">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-1140">
                  Response Notes (Internal)
                </label>
                <textarea className="w-full bg-background border border-white/10 rounded-lg p-3 text-sm focus:outline-none focus:border-accent-primary h-24" placeholder="What action was taken?" defaultValue="Called customer, offered free delivery on next order. Apologized." data-id="element-1141"></textarea>
              </div>

              <label className="flex items-center gap-2 cursor-pointer" data-id="element-1142">
                <input type="checkbox" className="rounded border-white/10 bg-background text-accent-primary focus:ring-accent-primary" defaultChecked data-id="element-1143" />
                <span className="text-sm" data-id="element-1144">Link to Flagged Orders</span>
              </label>
            </div>

            <div className="flex justify-end gap-3" data-id="element-1145">
              <Button variant="secondary" onClick={() => setShowResponseModal(false)} data-id="element-1146">
                Cancel
              </Button>
              <Button onClick={() => setShowResponseModal(false)} data-id="element-1147">
                Mark as Responded
              </Button>
            </div>
          </Card>
        </div>}
    </div>;
}